import * as React from "react";
const SvgFiRrCarAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M24 8.5A1.5 1.5 0 0 0 22.5 7s-.584 0-.625.008a30 30 0 0 0-2.562-3.959 3.9 3.9 0 0 0-1.978-1.357c-1.761-.856-8.909-.856-10.67 0a3.9 3.9 0 0 0-1.978 1.357 30 30 0 0 0-2.562 3.959C2.084 7 1.5 7 1.5 7A1.5 1.5 0 0 0 0 8.5V15a4 4 0 0 0 2 3.463V20a3 3 0 0 0 6 0v-1h8v1a3 3 0 0 0 6 0v-1.537A4 4 0 0 0 24 15zM6.274 4.266a1.9 1.9 0 0 1 .967-.659c1.519-.751 8-.751 9.518 0a1.9 1.9 0 0 1 .967.659 28.6 28.6 0 0 1 3.72 6.49 65.4 65.4 0 0 0-18.892 0 28.6 28.6 0 0 1 3.72-6.49M6 20a1 1 0 1 1-2 0v-1h2zm14 0a1 1 0 0 1-2 0v-1h2zm0-3H4a2 2 0 0 1-2-2v-2.143A76 76 0 0 1 12 12c3.349.065 6.69.35 10 .857V15a2 2 0 0 1-2 2M6 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0m14 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    />
  </svg>
);
export default SvgFiRrCarAlt;
